import React, { useState } from 'react'
import cx from 'classnames'
import PageHeader from './PageHeader'
import { capitalize } from 'libraries/lodash'
import url from 'libraries/front-end-core/core/url'
import { SEARCH, SMART_SEARCH, MW_LIST_DEALS } from 'constants/controllers'
import connect from 'components/shared/connect'
import { SearchHistory } from 'services/SessionService'
import Grid from '@mui/material/Grid'
import Truncate from 'components/shared/Truncate'
import TealToolTip from 'components/TealToolTip'
import { useSelector } from 'react-redux'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectAolName from 'redux/selectors/selectAolName'
import { selectSmartSearchEnabled } from 'redux/selectors/selectSmartSearchEnabled'

const TYPE_NAMES = {
  ca: 'News',
  leg: 'Legislation',
  legislation: 'Legislation',
  qa: 'Q&A',
  precedents: 'Documents',
  documents: 'Documents',
  markets: 'Markets',
  dealwatch: 'Markets'
}

const TYPE_URL = {
  qa: SEARCH,
  leg: SEARCH,
  legislation: SEARCH,
  ca: SEARCH,
  precedents: SEARCH,
  documents: SEARCH,
  markets: MW_LIST_DEALS,
  dealwatch: MW_LIST_DEALS // I think the old names are necessary for backwards compatibility
}

const TYPE_SEARCH = {
  qa: 'qa',
  leg: 'legislation',
  legislation: 'legislation',
  precedents: 'documents',
  documents: 'documents',
  ca: 'ca',
  markets: 'dealwatch',
  dealwatch: 'dealwatch'
}

const History = ({ history, className }) => {
  const aol = useSelector(selectAolName)

  return (
    <div className={cx(className, 'flex flex-column f5 lighter')}>
      <PageHeader title='My searches' />
      {history.map((item, index) => <HistoryItem key={index} {...{ index, aol, ...item }} />)}
    </div>
  )
}
const HistoryItem = ({ index, date, time, type, term: searchPhrase, aol }) => {
  const flavour = useSelector(selectFlavour)
  const smartSearchEnabled = useSelector(selectSmartSearchEnabled)
  // QA history entries are recorded as "qa-<flavour>" (e.g. "qa-full", "qa-skim"),
  // not plain "qa" - see the searchSwitch map in redux/actions/search.ts - so
  // normalize before looking anything up by type
  const normalizedType = type && type.startsWith('qa-') ? 'qa' : type
  const useSmartSearch = normalizedType === 'qa' && smartSearchEnabled
  const path = (normalizedType === 'markets' || normalizedType === 'dealwatch') && 'listdeals/all'
  const controller = useSmartSearch ? SMART_SEARCH : TYPE_URL[normalizedType]
  const params = { flavour, path, searchType: TYPE_SEARCH[normalizedType], searchPhrase, aol }
  // controller can still be undefined for a type this component doesn't know
  // about (e.g. future search types) - skip rendering that entry rather than
  // crashing the whole history list
  const href = controller && url(controller, params, { q: searchPhrase })

  const [clamped, setClamped] = useState()

  if (!href) {
    return null
  }

  return (
    <TealToolTip title={clamped ? searchPhrase : ''} placement='left'>
      <a
        className={cx('black no-underline pa6', { 'bg-white': index % 2 === 0 })}
        href={href}
        data-event-category='Account'
        data-event-action='Search History'
        data-event-label={`[${type}] ${searchPhrase}`}
        data-help-item='accountsearchhistory'
        data-help-position='bottom'
      >
        <Grid container>
          <Grid item xs={6}>
            <Truncate
              trimWhitespace
              width={192}
              onTruncate={(isClamped) => setClamped(isClamped)}
            >
              {searchPhrase}
            </Truncate>
          </Grid>
          <Grid item xs={3}>
            <div className='tl'>{TYPE_NAMES[normalizedType] || type} {flavour && capitalize(flavour)}</div>
          </Grid>
          <Grid item xs={3}>
            <div className='w-100 tr'>{date} {time}</div>
          </Grid>
        </Grid>
      </a>
    </TealToolTip>
  )
}

export default connect(SearchHistory)(History)
